import { stockMovement } from "@/stock/constants";

const prepareForInventarization = (operationType, items = []) => {
  const entities = stockMovement.entity.byForeignKey;
  const list = [];
  items.forEach((item) => {
    if (item.operation_type === operationType) {
      item.type = entities[`${item.entity}_id`];
      item.operation_description = 'Инвентаризация';
      list.push(item);
    }
  });
  return list;
};

export const stockOperationsEntity = {
  prepareForInventarization,
};



// WEBPACK FOOTER //
// ./src/stock/entities/stockOperationsEntity.js